import key from "../config/config";
import * as api from "../routes/userroutefront";
import axios, { setAuthorization } from "../config/axios";
import { setAuthToken } from "../lib/localStorage";
import { SET_USER_ACCOUNT } from "../constants";
import { decodeJwt } from "./jsonwebToken";

export const setAccountData = (data) => {
  // console.log('dats----------------------->',data)
  return {
    type: SET_USER_ACCOUNT,
    data: {
      userId: data._id ?? data.id,
      firstName: data.firstName,
      lastName: data.lastName,
      emailId: data.emailId,
      dateOfBirth: data.dateOfBirth,
      password: data.password,
      profile: data.profile,
      google2Fa: data.google2Fa,
      kycStatus: data.kycStatus,
    },
  };
};

export const userRegister = async (data) => {
  try {
    let respData = await axios({
      url: key.API_URL + api.register,
      method: "post",
      data: data,
    });
    return {
      status: respData?.data?.status,
      message: respData?.data?.message,
      result: respData?.data?.result,
    };
  } catch (err) {
    // console.log(err, 'userRegister_error')
    return {
      status: err?.response?.data?.status,
      message: err?.response?.data?.message,
      error: err?.response?.data?.errors,
    };
  }
};

export const sentOtp = async (data) => {
  try {
    let respData = await axios({
      url: key.API_URL + api.getCode,
      method: "post",
      data: data,
    });
    return {
      status: respData?.data?.status,
      message: respData?.data?.message,
      result: respData?.data?.result,
    };
  } catch (err) {
    // console.log(err, 'userLogin_error')
    return {
      status: err?.response?.data?.status,
      message: err?.response?.data?.message,
      error: err?.response?.data?.errors,
    };
  }
};

export const userLogin = async (data, dispatch) => {
  try {
    let respData = await axios({
      url: key.API_URL + api.login,
      method: "post",
      data: data,
    });
    console.log("respData", respData)
    if (respData?.data?.status == true) {
      const token = respData.data.token;
      setAuthorization(token);
      setAuthToken(token);
      decodeJwt(token, dispatch);
      dispatch(setAccountData(respData.data?.result));
    }
    return {
      status: respData?.data?.status,
      message: respData?.data?.message,
      result: respData?.data?.result,
    };
  } catch (err) {
    // console.log(err, 'userLogin_error')
    return {
      status: err?.response?.data?.status,
      message: err?.response?.data?.message,
      error: err?.response?.data?.errors,
    };
  }
};

export const getUserData = async (dispatch) => {
  try {
    let respData = await axios({
      url: key.API_URL + api.getUser,
      method: "get",
    });
    if (respData?.data?.status) {
      // /getUser rotates the 24-hour application token. Persist the rotated
      // token before an external flow (such as Persona KYC) navigates away;
      // previously it was decoded but discarded, so the old token could expire
      // during the hosted-flow round trip and the user returned logged out.
      const refreshedToken = respData.data.token;
      if (refreshedToken) {
        setAuthToken(refreshedToken);
        setAuthorization(refreshedToken);
      }
      if (typeof dispatch === "function") {
        decodeJwt(refreshedToken, dispatch);
        dispatch(setAccountData(respData.data?.result));
      }
    }
    return {
      status: respData?.data?.status,
      message: respData?.data?.message,
      result: respData?.data?.result,
    };
  } catch (err) {
    // 401 means token expired - axios interceptor handles redirect to /login
    const status = err?.response?.status;
    if (status === 401 || status === 400) {
      const { removeAuthToken } = await import("../lib/localStorage");
      const { removeAuthorization } = await import("../config/axios");
      removeAuthToken();
      removeAuthorization();
    }
    return {
      status: false,
      message: err?.response?.data?.message,
      error: err?.response?.data?.errors,
    };
  }
};

export const getUserWalletData = async () => {
  try {
    let respData = await axios({
      url: key.API_URL + api.getUserWallet,
      method: "get",
    });
    console.log(respData, "respData.data?.result");
    return {
      status: respData?.data?.status,
      message: respData?.data?.message,
      result: respData?.data?.result,
    };
  } catch (err) {
    // console.log(err, 'userLogin_error')
    return {
      status: err?.response?.data?.status,
      message: err?.response?.data?.message,
      error: err?.response?.data?.errors,
    };
  }
};

export const sendClaimRequest = async (data) => {
  try {
    let respData = await axios({
      url: key.API_URL + api.senduserClaimRequest,
      method: "post",
      data,
    });
    console.log(respData, "respData.data?.result");
    return {
      status: respData?.data?.status,
      message: respData?.data?.message,
      result: respData?.data?.result,
    };
  } catch (err) {
    // console.log(err, 'userLogin_error')
    return {
      status: err?.response?.data?.status,
      message: err?.response?.data?.message,
      error: err?.response?.data?.errors,
    };
  }
};
